<template>
  <!--add popup -->
  <div class="modal fade" id="add-sales-new">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper p-0 m-0">
          <div class="content p-0">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Ajouter une Facture</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Client</label>
                        <vue-select :options="clientData" v-model="form.nom_client" id="choosefive" placeholder="Choose"
                          :settings="{ tags: true }" />

                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Mode du Paiement</label>
                        <vue-select :options="PaiementMethods" v-model="form.mode_paiement" id="choosename"
                          placeholder="choose" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Conditions de règlement</label>
                        <vue-select :options="Conditions" v-model="form.conditions_paiement" id="choosensamess"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Délai de livraison </label>
                        <vue-select :options="delaisOptions" id="choosenamessa" placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Type</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select :options="producttsType" id="dazdadzdffghddh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="selectedType"
                              @input="handleType" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Produit / Service</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select :options="itemsList" id="dazdadzdffghh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="form.selectedProduct" />
                          </div>
                          <div class="col-lg-1 col-sm-2 col-2 ps-0">
                            <div class="add-icon">
                              <a href="javascript:void(0);" class="choose-add"
                                v-on:click="addProduct(selectedProducts, form)"><vue-feather type="plus-circle"
                                  class="plus"></vue-feather></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isCommandeLinesLoading" class="text-center my-4">
                    <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                  </div>
                  <div class="table-responsive no-pagination" v-show="!isCommandeLinesLoading">
                    <table class="table datanew">
                      <thead>
                        <tr>
                          <th>Produit / Service</th> <!-- 1 -->
                          <th>Type</th> <!-- 2 -->
                          <th>Prix Unitaire</th> <!-- 3 -->
                          <th>Quantité</th> <!-- 4 -->
                          <th>Réduc (%)</th> <!-- 5 -->
                          <th>Prix HT</th> <!-- 6 -->
                          <th>TVA</th> <!-- 7 -->
                          <th>Prix TTC</th> <!-- 8 -->
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in selectedProducts" :key="index">
                          <!-- 1. Produit / Service -->
                          <td>
                            <input v-if="product.item_id === 99" class="form-control" v-model="product.nom"
                              placeholder="Nom du produit / service" />
                            <span v-else>{{ product.nom }}</span>
                          </td>

                          <!-- 2. Type -->
                          <td>
                            <span v-if="product.item_id !== null">{{ product.item_type }}</span>
                            <vue-select v-else :options="Types" v-model="product.item_type"
                              @input="syncItemType(product)" />
                          </td>

                          <!-- 3. Prix Unitaire -->
                          <td>
                            <input type="number" min="0" class="form-control text-center"
                              v-model.number="product.prix_unitaire"
                              @input="changePrice(index, selectedProducts, form)" />
                          </td>

                          <!-- 4. Quantité (YOUR UI, CLEANED) -->
                          <td>
                            <div class="product-quantity d-flex align-items-center justify-content-center">
                              <span class="quantity-btn" @click="decreaseQuantity(index, selectedProducts, form)">
                                <vue-feather type="minus-circle" class="search"></vue-feather>
                              </span>

                              <input type="text" class="quntity-input text-center" v-model="product.quantite"
                                disabled />

                              <span class="quantity-btn" @click="increaseQuantity(index, selectedProducts, form)">
                                <vue-feather type="plus-circle" class="plus-circle"></vue-feather>
                              </span>
                            </div>
                          </td>

                          <!-- 5. Réduction -->
                          <td>
                            <div class="input-group percent-group">
                              <input type="number" min="0" max="100" step="0.01" class="form-control text-center"
                                v-model.number="product.reduc" @input="changePrice(index, selectedProducts, form)" />
                              <span class="input-group-text">%</span>
                            </div>
                          </td>
                          <!-- 6. Prix HT -->
                          <td class="text-end">
                            {{ product.montant_HT.toFixed(2) }}
                          </td>

                          <!-- 7. TVA -->
                          <td>
                            <span v-if="product.item_id !== null">
                              {{ product.tax }} %
                            </span>

                            <div v-else class="input-group tva-group">
                              <input type="number" min="0" max="100" step="0.01" class="form-control text-center"
                                v-model.number="product.tax" @input="changePrice(index, selectedProducts, form)" />
                              <span class="input-group-text">%</span>
                            </div>
                          </td>

                          <!-- 8. Prix TTC -->
                          <td class="text-end">
                            {{ product.montant_TTC.toFixed(2) }}
                          </td>

                          <!-- 9. Action -->
                          <td class="text-center">
                            <a class="confirm-text"
                              @click="deleteProduct(index, selectedProducts, form, deletedProducts)"
                              href="javascript:void(0);">
                              <vue-feather type="trash-2"></vue-feather>
                            </a>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 ms-auto">
                      <div class="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Totale HT</h4>
                            <h5>{{ Number(form.montant_HT).toFixed(2) }}</h5>
                          </li>
                          <li>
                            <h4>TVA</h4>
                            <h5>
                              {{ Number(form.montant_TTC - form.montant_HT).toFixed(2) }}
                            </h5>
                          </li>
                          <li>
                            <h4>Totale TTC</h4>
                            <h5>{{ Number(form.montant_TTC).toFixed(2) }}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <!-- <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Numéro de la Facture</label>
                        <div class="input-group select-code">
                          <input
                            type="text"
                            placeholder="0"
                            v-model="form.numero_devis"
                          />
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Statut de la Commande</label>
                        <vue-select
                          v-model="form.statut"
                          :options="Completed"
                          id="progressss"
                          placeholder="Choose"
                        />
                      </div>
                    </div> -->
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks mb-5">
                        <label>Statut de la Facture</label>
                        <vue-select v-model="form.statut_paiement" :options="Completed1" id="progressssdee"
                          placeholder="Choose" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Montant Payée</label>
                        <div class="input-group select-code">
                          <input type="number" min="0" class="form-control" placeholder="0"
                            v-model.number="form.montant_payé" @input="validateMontantPaye" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Montant Réstant</label>
                        <div class="input-group select-code">
                          <input type="number" min="0" class="form-control" placeholder="0" :value="remainingAmount"
                            disabled />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="input-blocks">
                        <label>Notes</label>
                        <textarea class="form-control" v-model="form.notes"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 text-end">
                      <button type="button" class="btn btn-cancel add-cancel me-3" data-bs-dismiss="modal">
                        Annuler
                      </button>
                      <button type="submit" class="btn btn-submit add-sale">
                        Ajouter
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /add popup -->

  <!-- details popup -->
  <div class="modal fade" id="sales-details-new">
    <div class="modal-dialog sales-details-modal">
      <div class="modal-content">
        <div class="page-wrapper details-blk">
          <div class="content p-0">
            <div class="page-header p-4 mb-0">
              <div class="add-item d-flex">
                <div class="page-title modal-datail">
                  <h4>Sales Detail : SL0101</h4>
                </div>
                <div class="page-btn">
                  <a href="javascript:void(0);" class="btn btn-added"><vue-feather type="plus-circle"
                      class="me-2"></vue-feather>
                    Add New Sales</a>
                </div>
              </div>
              <ul class="table-top-head">
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><vue-feather type="edit"
                      class="action-edit sales-action"></vue-feather></a>
                </li>
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="@/assets/img/icons/pdf.svg"
                      alt="img" /></a>
                </li>
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img
                      src="@/assets/img/icons/excel.svg" alt="img" /></a>
                </li>
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><vue-feather type="printer"
                      class="feather-rotate-ccw"></vue-feather></a>
                </li>
              </ul>
            </div>

            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div class="invoice-box table-height" style="
                      max-width: 1600px;
                      width: 100%;
                      overflow: auto;
                      padding: 0;
                      font-size: 14px;
                      line-height: 24px;
                      color: #555;
                    ">
                    <div class="sales-details-items d-flex">
                      <div class="details-item">
                        <h6>Customer Info</h6>
                        <p>
                          walk-in-customer<br />
                          walk-in-customer@example.com<br />
                          123456780<br />
                          N45 , Dhaka
                        </p>
                      </div>
                      <div class="details-item">
                        <h6>Company Info</h6>
                        <p>
                          DGT<br />
                          admin@example.com<br />
                          6315996770<br />
                          3618 Abia Martin Drive
                        </p>
                      </div>
                      <div class="details-item">
                        <h6>Invoice Info</h6>
                        <p>
                          Reference<br />
                          Payment Status<br />
                          Status
                        </p>
                      </div>
                      <div class="details-item">
                        <h5>
                          <span>SL0101</span>Paid<br />
                          Completed
                        </h5>
                      </div>
                    </div>
                    <h5 class="order-text">Order Summary</h5>
                    <div class="table-responsive no-pagination">
                      <table class="table datanew">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Purchase Price($)</th>
                            <th>Discount($)</th>
                            <th>Tax(%)</th>
                            <th>Tax Amount($)</th>
                            <th>Unit Cost($)</th>
                            <th>Total Cost(%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div class="productimgname">
                                <a href="javascript:void(0);" class="product-img stock-img">
                                  <img src="@/assets/img/products/product1.jpg" alt="product" />
                                </a>
                                <a href="javascript:void(0);">Nike Jordan</a>
                              </div>
                            </td>
                            <td>
                              <div class="product-quantity">
                                <span class="quantity-btn">+<vue-feather type="plus-circle"
                                    class="plus-circle"></vue-feather></span>
                                <input type="text" class="quntity-input" value="2" />
                                <span class="quantity-btn"><vue-feather type="minus-circle"
                                    class="search"></vue-feather></span>
                              </div>
                            </td>
                            <td>2000</td>
                            <td>500</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>1500</td>
                          </tr>
                          <tr>
                            <td>
                              <div class="productimgname">
                                <a href="javascript:void(0);" class="product-img stock-img">
                                  <img src="@/assets/img/products/product1.jpg" alt="product" />
                                </a>
                                <a href="javascript:void(0);">Apple Series 5 Watch</a>
                              </div>
                            </td>
                            <td>
                              <div class="product-quantity">
                                <span class="quantity-btn">+<vue-feather type="plus-circle"
                                    class="plus-circle"></vue-feather></span>
                                <input type="text" class="quntity-input" value="2" />
                                <span class="quantity-btn"><vue-feather type="minus-circle"
                                    class="search"></vue-feather></span>
                              </div>
                            </td>
                            <td>3000</td>
                            <td>400</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>1700</td>
                          </tr>
                          <tr>
                            <td>
                              <div class="productimgname">
                                <a href="javascript:void(0);" class="product-img stock-img">
                                  <img src="@/assets/img/products/product1.jpg" alt="product" />
                                </a>
                                <a href="javascript:void(0);">Lobar Handy</a>
                              </div>
                            </td>
                            <td>
                              <div class="product-quantity">
                                <span class="quantity-btn">+<vue-feather type="plus-circle"
                                    class="plus-circle"></vue-feather></span>
                                <input type="text" class="quntity-input" value="2" />
                                <span class="quantity-btn"><vue-feather type="minus-circle"
                                    class="search"></vue-feather></span>
                              </div>
                            </td>
                            <td>2500</td>
                            <td>500</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>2000</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="row">
                      <div class="col-lg-6 ms-auto">
                        <div class="total-order w-100 max-widthauto m-auto mb-4">
                          <ul>
                            <li>
                              <h4>Order Tax</h4>
                              <h5>$ 0.00</h5>
                            </li>
                            <li>
                              <h4>Discount</h4>
                              <h5>$ 0.00</h5>
                            </li>
                            <li>
                              <h4>Grand Total</h4>
                              <h5>$ 5200.00</h5>
                            </li>
                            <li>
                              <h4>Paid</h4>
                              <h5>$ 5200.00</h5>
                            </li>
                            <li>
                              <h4>Due</h4>
                              <h5>$ 0.00</h5>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /details popup -->

  <!-- edit popup -->
  <div class="modal fade" id="edit-sales-new" ref="editModalEl">
    <div class="modal-dialog edit-sales-modal">
      <div class="modal-content">
        <div class="page-wrapper p-0 m-0">
          <div class="content p-0">
            <div class="page-header p-4 mb-0">
              <div class="add-item new-sale-items d-flex">
                <div class="page-title">
                  <h4>Modier la Facture</h4>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm1">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Client</label>

                        <vue-select :options="clientData" v-model="form1.nom_client" id="choosefivei"
                          placeholder="Choose" :settings="{ tags: true }" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Mode du Paiement</label>
                        <vue-select :options="PaiementMethods" v-model="form1.mode_paiement" id="choosenamejj"
                          placeholder="choose" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Conditions de règlement</label>
                        <vue-select :options="Conditions" v-model="form1.conditions_paiement" id="choosensamessii"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Délai de livraison </label>
                        <vue-select :options="delaisOptions" v-model="form1.delaiLivraision" id="choosenamessaff"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Type</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select :options="producttsType" id="dazdadzdffghdddddh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="selectedType"
                              @input="handleType" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Produit / Service</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select ref="produitSelect" :options="itemsList" id="dazdadzdffghhassa"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="form1.selectedProduct" />
                          </div>
                          <div class="col-lg-1 col-sm-2 col-2 ps-0">
                            <div class="add-icon">
                              <a href="javascript:void(0);" class="choose-add" v-on:click="
                                addProduct(selectedProducts1, form1)
                                "><vue-feather type="plus-circle" class="plus"></vue-feather></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive no-pagination">
                    <table class="table datanew">
                      <thead>
                        <tr>
                          <th>Produit / Service</th>
                          <th>Type</th>
                          <th>Prix Unitaire</th>
                          <th>Quantité</th>

                          <th>Réduc (%)</th>
                          <th>Prix HT</th>
                          <th>TVA</th>
                          <th>Prix TTC</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in selectedProducts1" :key="index">

                          <!-- 1. Produit / Service -->
                          <td>
                            <span v-if="product.item_id !== null">{{ product.nom }}</span>
                            <input v-else class="form-control" v-model="product.nom"
                              placeholder="Nom du produit / service" />
                          </td>

                          <!-- 2. Type -->
                          <td>
                            <span v-if="product.item_id !== null">{{ product.item_type }}</span>
                            <vue-select v-else :options="Types" v-model="product.item_type"
                              @input="syncItemType(product)" />
                          </td>

                          <!-- 3. Prix Unitaire -->
                          <td>
                            <input type="number" min="0" class="form-control text-center"
                              v-model.number="product.prix_unitaire"
                              @input="changePrice(index, selectedProducts1, form1)" />
                          </td>

                          <!-- 4. Quantité (SAME AS ADD MODAL) -->
                          <td>
                            <div class="product-quantity d-flex align-items-center justify-content-center">
                              <span class="quantity-btn" @click="decreaseQuantity(index, selectedProducts1, form1)">
                                <vue-feather type="minus-circle" class="search"></vue-feather>
                              </span>

                              <input type="text" class="quntity-input text-center" v-model="product.quantite"
                                disabled />

                              <span class="quantity-btn" @click="increaseQuantity(index, selectedProducts1, form1)">
                                <vue-feather type="plus-circle" class="plus-circle"></vue-feather>
                              </span>
                            </div>
                          </td>

                          <!-- 5. Réduc (%) — SAME STYLE AS TVA -->
                          <td>
                            <div class="input-group percent-group">
                              <input type="number" min="0" max="100" step="0.01" class="form-control text-center"
                                v-model.number="product.reduc" @input="changePrice(index, selectedProducts1, form1)" />
                              <span class="input-group-text">%</span>
                            </div>
                          </td>

                          <!-- 6. Prix HT -->
                          <td class="text-end">
                            {{ Number(product.montant_HT).toFixed(2) }}
                          </td>

                          <!-- 7. TVA -->
                          <td>
                            <span v-if="product.item_id !== null">
                              {{ product.tax }} %
                            </span>

                            <div v-else class="input-group tva-group">
                              <input type="number" min="0" max="100" step="0.01" class="form-control text-center"
                                v-model.number="product.tax" @input="changePrice(index, selectedProducts1, form1)" />
                              <span class="input-group-text">%</span>
                            </div>
                          </td>

                          <!-- 8. Prix TTC -->
                          <td class="text-end">
                            {{ Number(product.montant_TTC).toFixed(2) }}
                          </td>

                          <!-- 9. Action -->
                          <td class="text-center">
                            <a class="confirm-text"
                              @click="deleteProduct(index, selectedProducts1, form1, deletedProducts1)"
                              href="javascript:void(0);">
                              <vue-feather type="trash-2"></vue-feather>
                            </a>
                          </td>

                        </tr>

                      </tbody>
                    </table>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 ms-auto">
                      <div class="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Totale HT</h4>
                            <h5>
                              {{
                                form1.montant_HT
                                  ? Number(form1.montant_HT).toFixed(2)
                                  : 0
                              }}
                            </h5>
                          </li>
                          <li>
                            <h4>TVA</h4>
                            <h5>
                              {{
                                form1.montant_HT
                                  ? Number(form1.montant_TTC - form1.montant_HT).toFixed(2)
                                  : 0
                              }}
                            </h5>
                          </li>
                          <li>
                            <h4>Totale TTC</h4>
                            <h5>
                              {{
                                form1.montant_TTC
                                  ? Number(form1.montant_TTC).toFixed(2)
                                  : 0
                              }}
                            </h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <!-- <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Numéro de la Commande</label>
                        <div class="input-group select-code">
                          <input
                            type="text"
                            placeholder="0"
                            v-model="form1.numero_commande"
                          />
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Numéro de la Facture</label>
                        <div class="input-group select-code">
                          <input
                            type="text"
                            placeholder="0"
                            v-model="form1.numero_devis"
                          />
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Statut de la Commande</label>
                        <vue-select
                          v-model="form1.statut"
                          :options="Completed"
                          id="progressss^^m"
                          placeholder="Choose"
                        />
                      </div>
                    </div> -->
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks mb-5">
                        <label>Statut de la Facture</label>
                        <vue-select v-model="form1.statut_paiement" :options="Completed1" id="progressssdeeplpl"
                          placeholder="Choose" :settings="statusPaymentSettingsObj" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Montant Payée</label>
                        <div class="input-group select-code">
                          <input type="number" min="0" class="form-control" placeholder="0"
                            v-model.number="form1.montant_payé" @input="validateMontantPaye1" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Montant Réstant</label>
                        <div class="input-group select-code">
                          <input type="number" min="0" class="form-control" placeholder="0" :value="remainingAmount1"
                            disabled />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                      <div class="input-blocks">
                        <label>Fichier signé / cachet (PDF ou image)</label>
                        <input type="file" class="form-control" accept="application/pdf,image/*"
                          @change="onSignedFileEditChange" />
                        <small class="text-muted">Max 5 Mo.</small>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="input-blocks">
                        <label>Notes</label>
                        <textarea class="form-control" v-model="form1.notes"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 text-end">
                      <button type="button" class="btn btn-cancel add-cancel me-3" data-bs-dismiss="modal">
                        Annuler
                      </button>
                      <button type="submit" class="btn btn-submit add-sale">
                        Modifier
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /edit popup -->

  <!-- show payment Modal -->
  <div class="modal fade" id="showpayment" tabindex="-1" aria-labelledby="showpayment" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered stock-adjust-modal">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Show Payments</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="modal-body-table total-orders">
                    <div class="table-responsive">
                      <table class="table datanew">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Reference</th>
                            <th>Amount</th>
                            <th>Paid By</th>
                            <th class="no-sort">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0101</td>
                            <td>$1500</td>
                            <td>Cash</td>
                            <td class="action-table-data">
                              <div class="edit-delete-action">
                                <a class="me-3 p-2" href="javascript:void(0);">
                                  <vue-feather type="printer" class="printer"></vue-feather>
                                </a>
                                <a class="me-3 p-2" href="javascript:void(0);" data-bs-toggle="modal"
                                  data-bs-target="#editpayment">
                                  <vue-feather type="edit" class="feather-edit"></vue-feather>
                                </a>
                                <a class="confirm-text p-2" href="javascript:void(0);" @click="showConfirmation">
                                  <vue-feather type="trash-2" class="feather-trash-2"></vue-feather>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- show payment Modal -->

  <!-- Create payment Modal -->
  <div class="modal fade" id="createpayment" tabindex="-1" aria-labelledby="createpayment" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 custom-modal-header">
          <div class="page-title">
            <h4>Create Payments</h4>
          </div>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-blocks">
                  <label> Date</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="calendar" class="info-img"></vue-feather>
                    <input type="text" class="datetimepicker" placeholder="Choose Date" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Reference</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Received Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Paying Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Payment type</label>
                  <vue-select :options="OnlineOne" id="online01" placeholder="Choose" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-blocks">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                  <p>Maximum 60 Characters</p>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="modal-footer-btn">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Create payment Modal -->

  <!-- edit payment Modal -->
  <div class="modal fade" id="editpayment" tabindex="-1" aria-labelledby="editpayment" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 custom-modal-header">
          <div class="page-title">
            <h4>Edit Payments</h4>
          </div>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-blocks">
                  <label>19 Jan 2023</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="calendar" class="info-img"></vue-feather>
                    <input type="text" class="datetimepicker form-control" placeholder="Select Date" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Reference</label>
                  <input type="text" value="INV/SL0101" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Received Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" value="1500" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Paying Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" value="1500" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Payment type</label>
                  <vue-select :options="Online" id="cash" placeholder="Cash" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-blocks summer-description-box transfer">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                </div>
                <p>Maximum 60 Characters</p>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="modal-footer-btn mb-3 me-3">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- edit payment Modal -->
</template>
<style>
/* TVA input looks like a single bordered box */
.tva-group {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  overflow: hidden;
  height: 38px;
}

/* Remove inner borders */
.tva-group .form-control {
  border: none;
  box-shadow: none;
  height: 100%;
}

.tva-group .input-group-text {
  border: none;
  background-color: #f8f9fa;
  font-weight: 600;
  padding: 0 10px;
}

/* Focus state (important UX) */
.tva-group:focus-within {
  border-color: #FF9900;
}

/* Shared style for TVA & Réduction */
.percent-group {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  overflow: hidden;
  height: 38px;
}

.percent-group .form-control {
  border: none;
  box-shadow: none;
  height: 100%;
}

.percent-group .input-group-text {
  border: none;
  background-color: #f8f9fa;
  font-weight: 600;
  padding: 0 10px;
}

.percent-group:focus-within {
  border-color: #FF9900;
}
</style>

<script>
import { getClientsData, createClient } from "@/services/clientsService";
import { getProductsDataInStock, getServicesData } from "@/services/productsService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import { getLignesCommandeDataByCommandeId } from "@/services/devisService";
import {
  createCommand,
  createCommandLine,
  updateCommand,
  updateCommandLine,
  deleteCommandLine,
} from "@/services/devisService";

import { createFacture, updateFacture } from "@/services/facturesService";

import Swal from "sweetalert2";
import { toast } from "vue3-toastify";
const currentDate = new Date();
const clientData = [];
const clientIds = [];
const productsData = [];
const productsIds = [];
const selectedProducts = [];
const selectedProducts1 = [];
const deletedProducts = [];
const deletedProducts1 = [];
const insertedProducts = [];
const itemsList = [];

const commandeLinesCache = new Map();
const COMMAND_LINES_CACHE_TTL_MS = 5000;
let activeCommandeLinesFetch = null;
let activeCommandeLinesId = null;
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    remainingAmount() {
      const total = parseFloat(this.form.montant_TTC) || 0;
      const paid = parseFloat(this.form.montant_payé) || 0;
      return (total - paid).toFixed(2); // 2 digits after comma
    },
    remainingAmount1() {
      const total = parseFloat(this.form1.montant_TTC) || 0;
      const paid = parseFloat(this.form1.montant_payé) || 0;
      return (total - paid).toFixed(2); // 2 digits after comma
    },
  },
  data() {
    return {
      form: {
        nom_client: "",
        selectedProduct: "",
        montant_HT: 0,
        montant_TTC: 0,

        // New fields
        date_creation: currentDate,
        statut: "",
        mode_paiement: "",
        conditions_paiement: "",
        date_livraison: currentDate,
        client_id: null,
        montant_total: 0,
        montant_taxe: 0,
        montant_payé: 0,
        montant_restant: 0,
        montant_remise: 0,
        numero_commande: "",
        notes: "",
        cree_par: null,
        societe_id: null,
        numero_devis: "",
        statut1: "",
        statut_paiement: "",
      },
      form1: {
        nom_client: "",
        selectedProduct: "",
        montant_HT: 0,
        montant_TTC: 0,
        montant_payé: 0,
        montant_restant: 0,

        // New fields
        date_creation: currentDate,
        statut: "",
        mode_paiement: "",
        conditions_paiement: "",
        date_livraison: currentDate,
        client_id: null,
        montant_total: 0,
        montant_taxe: 0,
        montant_remise: 0,
        numero_commande: "",
        notes: "",
        cree_par: 2,
        societe_id: 1,
        numero_devis: "",
        statut1: "",
        delaiLivraision: "",
        commande_id: null,
        statut_paiement: "",
      },
      signedFileEdit: null,
      Choose: ["Choose", "Customer Name"],
      Choosename: ["Choose", "Supplier Name"],
      Completed: ["ANNULEE", "TERMINEE", "EN_ATTENTE", "EN_COURS", "EXPEDIEE"],
      // Payment status options: keep value codes, show French labels
      Completed1: [
        { id: "PAYÉ", text: "Payé" },
        { id: "IMPAYÉ", text: "Impayé" },
        { id: "PARTIELLEMENT_PAYÉ", text: "Partiellement payé" },
        { id: "ANNULÉ", text: "Annulé" },
        { id: "EN_RETARD", text: "En retard" },
      ],
      Types: ["PRODUIT", "SERVICE"],
      Thomas: ["Thomas", "Name"],
      Shoes: ["Dazzle Shoes", "Supplier Name"],
      Online: ["Choose", "Online", "Cash"],
      OnlineOne: ["Choose", "Online", "Cash"],
      PaiementMethods: [
        "Carte Bancaire",
        "Chèque",
        "Espèce",
        "Ordre de Prélèvement",
        "Virement Bancaire",
      ],
      // Stable settings object for select2; set dropdownParent in mounted
      statusPaymentSettingsObj: null,
      Conditions: [
        "A réception",
        "10 jours",
        "10 jours fin de mois",
        "14 jours",
        "14 jours fin de mois",
        "30 jours",
        "30 jours fin de mois",
        "60 jours",
        "60 jours fin de mois",
        "A commande",
        "A Livraison",
        "50/50",
      ],
      delaisOptions: [
        "Immédiate (0 jour)",
        "1 jour",
        "2 jours",
        "3 jours",
        "4 jours",
        "5 jours",
        "1 semaine (7 jours)",
        "2 semaines (14 jours)",
        "3 semaines (21 jours)",
        "4 semaines (28 jours)",
        "5 semaines (35 jours)",
        "6 semaines (42 jours)",
        "8 semaines (56 jours)",
        "10 semaines (70 jours)",
        "12 semaines (84 jours)",
        "14 semaines (98 jours)",
        "16 semaines (112 jours)",
      ],
      startdate: currentDate,
      producttsType: ["PRODUIT", "SERVICE"],
      selectedType: "PRODUIT",
      dateFormat: "dd-MM-yyyy",
      clientData,
      clientIds,
      clients: [],
      productsData,
      productsIds,
      selectedProducts,
      selectedProducts1,
      deletedProducts,
      deletedProducts1,
      insertedProducts,
      itemsList,
      isCommandeLinesLoading: false,
    };
  },
  methods: {
    async loadCommandeLines(commandeId) {
      if (!commandeId) {
        this.selectedProducts1 = [];
        this.deletedProducts1 = [];
        this.isCommandeLinesLoading = false;
        return [];
      }

      const now = Date.now();
      const cached = commandeLinesCache.get(commandeId);
      if (cached && now - cached.timestamp < COMMAND_LINES_CACHE_TTL_MS) {
        this.applyCommandeLines(cached.data);
        this.isCommandeLinesLoading = false;
        return cached.data;
      }

      this.isCommandeLinesLoading = true;

      if (activeCommandeLinesFetch && activeCommandeLinesId === commandeId) {
        try {
          const data = await activeCommandeLinesFetch;
          this.applyCommandeLines(data);
          return data;
        } catch (error) {
          return [];
        } finally {
          this.isCommandeLinesLoading = false;
        }
      }

      const fetchPromise = (async () => {
        try {
          const data = await getLignesCommandeDataByCommandeId(commandeId);
          commandeLinesCache.set(commandeId, {
            data,
            timestamp: Date.now(),
          });
          return data;
        } catch (error) {
          const status = error?.response?.status;
          if (status === 429) {
            toast.error("Trop de requêtes reçues. Merci de patienter quelques secondes.");
          } else {
            const message = error?.response?.data?.message || "Impossible de récupérer les lignes de commande.";
            toast.error(message);
          }
          throw error;
        }
      })();

      activeCommandeLinesId = commandeId;
      activeCommandeLinesFetch = fetchPromise;

      try {
        const data = await fetchPromise;
        this.applyCommandeLines(data);
        return data;
      } finally {
        activeCommandeLinesFetch = null;
        activeCommandeLinesId = null;
        this.isCommandeLinesLoading = false;
      }
    },
    applyCommandeLines(data) {
      const mapped = Array.isArray(data)
        ? data.map((m) => {
          const montantHT = parseFloat(m.montant_HT) || 0;
          const montantTTC = parseFloat(m.montant_TTC) || 0;
          const rate = montantHT > 0 ? ((montantTTC / montantHT - 1) * 100) : 0;

          return {
            id: m.id,
            quantite: m.quantite,
            prix_unitaire: m.prix_unitaire,
            reduc: Number(m.reduction ?? 0),
            montant_HT: montantHT,
            montant_TTC: montantTTC,
            item_type: m.item_type,
            item_type1: m.item_type, // already lowercase from backend
            item_id: m.item_id,
            nom: m.item_data ? m.item_data.nom : m.nom_libre,
            tax: Number(rate.toFixed(2)) || 0,
            societe_id: m.societe_id,
          };
        })
        : [];

      this.selectedProducts1 = mapped;
      this.deletedProducts1 = [];
      if (this.form1) {
        this.recalculateTotals(this.selectedProducts1, this.form1);
      }
    },
    changePrice(index, list, form) {
      this.recalculateLine(list[index]);
      this.recalculateTotals(list, form);
    },
    increaseQuantity(index, list, form) {
      if (list[index].quantite !== undefined) {
        list[index].quantite++;
        this.recalculateLine(list[index]);
        this.recalculateTotals(list, form);
      }
    },
    decreaseQuantity(index, list, form) {
      if (list[index].quantite !== undefined && list[index].quantite > 1) {
        list[index].quantite--;
        this.recalculateLine(list[index]);
        this.recalculateTotals(list, form);
      }
    },
    deleteProduct(index, list, form, deleted) {
      const removed = list.splice(index, 1);
      if (removed.length) deleted.push(removed[0]);
      this.recalculateTotals(list, form);
    },
    normalizeTax(value) {
      if (value === null || value === undefined) return 0;
      const n = Number(String(value).replace(',', '.'));
      return isNaN(n) ? 0 : n;
    },
    normalizePercent(value) {
      if (value === null || value === undefined) return 0;
      const n = Number(String(value).replace(',', '.'));
      if (isNaN(n)) return 0;
      if (n < 0) return 0;
      if (n > 100) return 100;
      return n;
    },
    recalculateLine(line) {
      const qty = Math.max(1, Number(line.quantite) || 1);
      const unit = Math.max(0, Number(line.prix_unitaire) || 0);
      const tax = this.normalizeTax(line.tax);
      const reduc = this.normalizePercent(line.reduc);

      const unitAfterDiscount = unit * (1 - reduc / 100);
      line.montant_HT = unitAfterDiscount * qty;
      line.montant_TTC = line.montant_HT + line.montant_HT * (tax / 100);
    }
    ,
    recalculateTotals(list, form) {
      form.montant_HT = 0;
      form.montant_TTC = 0;
      list.forEach((product) => {
        form.montant_HT += Number(product.montant_HT) || 0;
        form.montant_TTC += Number(product.montant_TTC) || 0;
      });
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    // Select2 accent-insensitive matcher for search
    accentMatcher(params, data) {
      try {
        if (!params || !params.term) return data;
        if (!data || !data.text) return null;
        const normalize = (s) => String(s)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
        const term = normalize(params.term);
        const text = normalize(data.text);
        return text.includes(term) ? data : null;
      } catch (_) {
        return data;
      }
    },

    // Settings factory for Select2 inside edit modal to keep dropdown aligned
    statusPaymentSettings() {
      const parentEl = this.$refs?.editModalEl ?? null;
      return {
        width: '100%',
        minimumResultsForSearch: 0,
        dropdownParent: parentEl || undefined,
        matcher: this.accentMatcher,
      };
    },
    async getClientsData() {
      this.clientData = [];
      this.clientIds = [];
      if (localStorage.getItem("clients") != null) {
        const data = JSON.parse(localStorage.getItem("clients"));
        data.map((m) => {
          this.clientData.push(m.nom + " " + m.prenom);
          this.clientIds.push(m.id);
        });
      } else {
        try {
          const data = await getClientsData();
          data.map((m) => {
            this.clientData.push(m.nom + " " + m.prenom);
            this.clientIds.push(m.id);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
    },
    getClientID(option) {
      const label = String(option || '').trim();
      const index = this.clientData.indexOf(label);
      if (index !== -1) return this.clientIds[index];
      return -1; // indicate not found/new tag
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    async getProductsData() {
      this.productsData = [];
      this.productsIds = [];
      if (localStorage.getItem("products") != null) {
        const data = JSON.parse(localStorage.getItem("products"));
        data.map((m) => {
          m.item_type = "product";
          this.productsData.push(m.nom);
          this.productsIds.push(m);
        });
      } else {
        try {
          const data = await getProductsDataInStock();
          data.map((m) => {
            m.item_type = "product";
            this.productsData.push(m.nom);
            this.productsIds.push(m);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }

      if (localStorage.getItem("services") != null) {
        const data = JSON.parse(localStorage.getItem("services"));
        data.map((m) => {
          m.item_type = "service";
          this.productsData.push(m.nom);
          this.productsIds.push(m);
        });
      } else {
        try {
          const data = await getServicesData();
          data.map((m) => {
            m.item_type = "service";
            this.productsData.push(m.nom);
            this.productsIds.push(m);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
      this.itemsList = this.productsIds
        .filter((product) => product.item_type === "product")
        .map((product) => product.nom);
    },
    getProductsID(option) {
      let index = this.productsData.indexOf(option);
      if (index != -1) {
        return this.productsIds[index];
      }
      return {};
    },
    onSignedFileEditChange(event) {
      const file = event?.target?.files ? event.target.files[0] : null;
      this.signedFileEdit = file || null;
    },
    getProductName(option) {
      let product = productsIds.find((m) => m.id === option);
      let index = this.productsIds.indexOf(product);
      if (index != -1) {
        return this.productsData[index];
      }
      return {};
    },
    addProduct(list, form) {
      const item = this.getProductsID(form.selectedProduct);

      // MANUAL ITEM
      if (!item || !item.id) {
        list.push({
          id: null,
          quantite: 1,
          prix_unitaire: 0,
          reduc: 0,
          montant_HT: 0,
          montant_TTC: 0,
          item_type: this.selectedType,
          item_type1: this.selectedType,
          item_id: null,
          nom: "",
          tax: 20,
          societe_id: this.form.societe_id,
        });
      }
      // DB ITEM
      else {
        const quantite = 1;
        const tax = item.item_type === "product" ? item.taux_tva : item.taux_taxe;
        const rate = this.normalizeTax(tax);
        const montant_HT = item.prix_vente * quantite;
        const montant_TTC = montant_HT + montant_HT * (rate / 100);

        list.push({
          id: null,
          quantite,
          prix_unitaire: item.prix_vente,
          reduc: 0,
          montant_HT,
          montant_TTC,
          item_type: this.selectedType,
          item_type1: this.selectedType,
          item_id: item.id,
          nom: item.nom,
          tax: rate,
          societe_id: item.societe_id,
        });
      }

      this.recalculateTotals(list, form);
      form.selectedProduct = "";
    }
    ,
    async submitForm() {
      try {
        const token = localStorage.getItem("access_token");
        const user = decodeToken(token);
        this.form.societe_id = user.societe_id;
        this.form.cree_par = user.user_id;
        // Resolve or create client if the selection is a new tag
        let cid = this.getClientID(this.form.nom_client);
        if (cid === -1 || cid === null || cid === undefined) {
          try {
            const name = String(this.form.nom_client || '').trim();
            if (name) {
              const parts = name.split(/\s+/);
              const nom = parts[0];
              const prenom = parts.slice(1).join(' ');
              const created = await createClient({ nom, prenom, societe_id: this.form.societe_id });
              if (created && created.id) {
                // update local caches used by selects
                this.clientData.push(`${created.nom} ${created.prenom || ''}`.trim());
                this.clients.push(created);
                this.clientIds.push(created.id);
                cid = created.id;
              }
            }
          } catch (e) {
            // fallback: keep cid as -1 to fail validation downstream
          }
        }
        this.form.client_id = cid;

        try {
          const response = await createCommand({
            date_creation: this.form.date_creation,
            statut: "TERMINEE",
            mode_paiement: this.form.mode_paiement,
            conditions_paiement: this.form.conditions_paiement,
            date_livraison: this.form.date_livraison,
            client_id: this.form.client_id,
            montant_total: this.form.montant_TTC,
            montant_taxe: this.form.montant_TTC - this.form.montant_HT,

            // numero_commande: this.form.numero_devis,
            notes: this.form.notes,
            cree_par: this.form.cree_par,
            societe_id: this.form.societe_id,
          });
          if (response !== null) {
            const commande_id = response.id;

            // Create Command Lines
            for (const product of selectedProducts) {
              try {
                await createCommandLine({
                  quantite: product.quantite,
                  prix_unitaire: product.prix_unitaire,
                  reduction: product.reduc ?? 0,
                  montant_HT: product.montant_HT,
                  montant_TTC: product.montant_TTC,
                  commande_id: commande_id,
                  item_type: product.item_type,
                  item_id: product.item_id === null ? null : product.item_id,
                  nom_libre: product.item_id === null ? product.nom : null,
                  societe_id: this.form.societe_id,
                });
              } catch (error) {
                console.error(error);
                const message =
                  error?.response?.data?.message || "Une erreur est survenue";
                toast.error(message);
                toast.error(error.response.data.error);
              }
            }

            commandeLinesCache.delete(commande_id);
            // let devis_id = null;
            // try {
            //   const response1 = await createDevis({
            //     statut: "VALIDÉ",
            //     commande_id: commande_id,
            //     numero_devis: this.form.numero_devis,
            //     notes: this.form.notes,
            //     societe_id: this.form.societe_id,
            //   });
            //   devis_id = response1.id;
            // } catch (error) {
            //   console.error(error);
            //   const message =
            //     error?.response?.data?.message || "Une erreur est survenue";
            //   toast.error(message);
            // }

            try {
              await createFacture({
                date_creation: this.form.date_creation
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
                date_echeance: this.form.date_creation
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
                statut_paiement: this.form.statut_paiement,
                date_paiement: this.form.date_creation
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
                montant_total: this.form.montant_TTC,
                montant_payé: this.form.montant_payé,
                montant_restant: this.form.montant_restant,
                commande_id: commande_id,
                // devis_id: devis_id,
                montant_taxe: this.form.montant_TTC - this.form.montant_HT,

                montant_remise: this.form.montant_remise,
                societe_id: this.form.societe_id,
              });
            } catch (error) {
              console.error(error);
              const message =
                error?.response?.data?.message || "Une erreur est survenue";
              toast.error(message);
              toast.error(error.response.data.error);
            }

            this.$emit("facture-added");
            const modalElement = document.getElementById("add-sales-new");
            const modal =
              Modal.getInstance(modalElement) || new Modal(modalElement);
            modal.hide();
          }
        } catch (error) {
          console.error(error);
          const message =
            error?.response?.data?.message || "Une erreur est survenue";
          toast.error(message);
          toast.error(error.response.data.error);
        }
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message || "Une erreur est survenue";
        toast.error(message);
        toast.error(error.response.data.error);
      }
    },
    async submitForm1() {
      try {
        const dc = this.normalizeDateForApi(this.form1.date_creation) || this.normalizeDateForApi(new Date());
        const de = this.normalizeDateForApi(this.form1.date_livraison) || dc;

        await updateCommand(this.form1.commande_id, {
          date_creation: dc,
          statut: this.form1.statut,
          mode_paiement: this.form1.mode_paiement,
          conditions_paiement: this.form1.conditions_paiement,
          date_livraison: de,
          client_id: this.form1.client_id,
          montant_total: this.form1.montant_TTC,
          montant_taxe: this.form1.montant_TTC - this.form1.montant_HT,
          // numero_commande: this.form1.numero_commande,
          notes: this.form1.notes,
          cree_par: this.form1.cree_par,
          societe_id: this.form1.societe_id,
        });
        for (const product of this.selectedProducts1) {
          if (product.id !== null) {
            
            await updateCommandLine(product.id, {
              
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              reduction: product.reduc ?? 0,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: this.form1.commande_id,
              item_type: product.item_type,
              item_id: product.item_id === null ? null : product.item_id,
              societe_id: this.form1.societe_id,
              nom_libre: product.item_id === null ? product.nom : null,
            });
          } else {
            await createCommandLine({
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              reduction: product.reduc ?? 0,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: this.form1.commande_id,
              item_type: product.item_type,
              item_id: product.item_id === null ? null : product.item_id,
              nom_libre: product.item_id === null ? product.nom : null,
              societe_id: this.form1.societe_id,
            });
          }
        }
        for (const product of this.deletedProducts1) {
          if (product[0].id !== null) {
            await deleteCommandLine(product[0].id, this.form1.commande_id);
          }
        }

        commandeLinesCache.delete(this.form1.commande_id);
        // const response1 = await updateDevis(this.form1.devis_id, {
        //   // date_creation: this.startdate,
        //   statut: this.form1.statut1,
        //   commande_id: this.form1.commande_id,
        //   numero_devis: this.form1.numero_devis,
        //   // valide_jusqua: this.form1.date_livraison,
        //   notes: this.form1.notes,
        //   societe_id: this.form1.societe_id,
        // });
        const facturePayload = new FormData();
        const addIfPresent = (key, value) => {
          if (value !== null && value !== undefined && value !== "") {
            facturePayload.append(key, value);
          }
        };

        addIfPresent("statut_paiement", this.form1.statut_paiement || "");
        addIfPresent("montant_total", this.form1.montant_TTC ?? null);
        addIfPresent("montant_payé", this.form1.montant_payé ?? null);
        addIfPresent("montant_restant", this.form1.montant_restant ?? null);
        addIfPresent(
          "montant_taxe",
          this.form1.montant_TTC - this.form1.montant_HT
        );

        addIfPresent("montant_remise", this.form1.montant_remise ?? null);
        addIfPresent("societe_id", this.form1.societe_id ?? null);

        if (dc) addIfPresent("date_creation", dc);
        if (de) addIfPresent("date_echeance", de);

        addIfPresent("notes", this.form1.notes || "");
        if (this.signedFileEdit) {
          facturePayload.append("pdf", this.signedFileEdit);
        }
        await updateFacture(this.form1.id, facturePayload);
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message || "Une erreur est survenue";
        toast.error(message);
        toast.error(error.response.data.error);
      }
      this.$emit("edit-added");
      const modalElement = this.$refs?.editModalEl ?? null;
      if (modalElement) {
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    syncItemType(product) {
      if (!product) return;

      // Backend enum-safe
      product.item_type1 = product.item_type;

      this.recalculateLine(product);
    },
    formatDateForInput(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return ""; // handle invalid date
      return date.toISOString().split("T")[0]; // keep only YYYY-MM-DD
    },
    normalizeDateForApi(value) {
      if (!value) return null;
      const date = new Date(value);
      if (isNaN(date)) return null;
      return date.toISOString().split("T")[0];
    },
    validateMontantPaye() {
      const total = parseFloat(this.form.montant_TTC) || 0;
      const paid = parseFloat(this.form.montant_payé) || 0;

      if (paid > total) {
        this.form.montant_payé = total.toFixed(2);
      }
    },
    validateMontantPaye1() {
      const total = parseFloat(this.form1.montant_TTC) || 0;
      const paid = parseFloat(this.form1.montant_payé) || 0;

      if (paid > total) {
        this.form1.montant_payé = total.toFixed(2);
      }
    },
  },
  mounted() {
    this.getClientsData();
    this.getProductsData();
    try {
      const parentEl = this.$refs?.editModalEl ?? null;
      this.statusPaymentSettingsObj = {
        width: '100%',
        minimumResultsForSearch: 0,
        dropdownParent: parentEl || undefined,
        matcher: this.accentMatcher,
      };
    } catch (_) {
      this.statusPaymentSettingsObj = { width: '100%', minimumResultsForSearch: 0 };
    }
  },
  beforeUnmount() {
    if (activeCommandeLinesId && activeCommandeLinesFetch) {
      activeCommandeLinesFetch = null;
      activeCommandeLinesId = null;
    }
    Object.values(this.$refs)
      .filter((refEl) => refEl && typeof refEl.destroy === "function")
      .forEach((refEl) => {
        try {
          refEl.destroy();
        } catch (_) {
          /* ignore */
        }
      });
  },
  watch: {
    "form.montant_payé"(newVal) {
      const total = parseFloat(this.form.montant_TTC) || 0;
      const paid = parseFloat(newVal) || 0;

      if (paid > total) {
        this.form.montant_payé = total.toFixed(2); // Or you can set it to total directly
      }
    },
    data: {
      immediate: true,
      async handler(newData) {
        if (!newData) return;
        (this.form1.devis_id = newData.devis_id),
          (this.form1.nom_client = this.getClientName(newData.client_id));
        this.form1.id = newData.id;
        this.form1.montant_HT = newData.montant_taxe;
        this.form1.montant_TTC = newData.montant_total;
        this.form1.mode_paiement = newData.mode_paiement;
        this.form1.client_id = newData.client_id;
        this.form1.notes = newData.notes;
        this.form1.societe_id = newData.societe_id;
        this.form1.numero_devis = newData.numero_devis;
        this.form1.statut1 = newData.statut;
        this.form1.delaiLivraision = "1 semaine (7 jours)";
        this.form1.commande_id = newData.commande_id;
        this.form1.statut_paiement = newData.statut_paiement;
        // Safely access nested fields
        if (newData.commande) {
          this.form1.date_creation = new Date(newData.commande?.date_creation);
          this.form1.statut = newData.commande.statut;
          this.form1.conditions_paiement = newData.commande.conditions_paiement;
          this.form1.date_livraison = new Date(
            newData.commande?.date_livraison
          );
          this.form1.numero_commande = newData.commande.numero_commande;
          this.form1.cree_par = newData.commande.cree_par;
        } else {
          console.warn("commande is undefined in newData");
        }

        try {
          await this.loadCommandeLines(this.form1.commande_id);
        } catch (_) {
          // handled via toast in loadCommandeLines; keep previous data displayed.
        }
      },
    },
    selectedType(value) {
      const type = value === "PRODUIT" ? "product" : "service";

      this.itemsList = this.productsIds
        .filter((product) => product.item_type === type)
        .map((product) => product.nom);
    },
  },
};
</script>
